import React, {useState} from 'react';
import { useMutation } from '@apollo/react-hooks';
import SpinnerComponent from '../SpinnerComponent'
import OWNEDFIGURE_QUERY from '../../graphql/ownedfigurequery';
import {UPDATE_OWNEDFIGURE, REMOVE_OWNEDFIGURE, ADD_IMAGE_TO_OWNED_FIGURE, REMOVE_IMAGE} from '../../graphql/mutations';
import { withRouter } from 'react-router-dom';
import StarRatingComponent from 'react-star-rating-component';
import { FileUploadImage } from '../FileUploadButton';
import 'lazysizes';
import ManageAccessories from '../ManageAccessories';
import swal from 'sweetalert'
import EditFigureMenu from '../EditFigure/EditFigureMenu';




const EditFigure = (props) => {

    const {figure, collection} = props

    console.log(figure)
    
    let allAccessory = []
    figure.ownedaccessory.forEach(({id, name}) => {
        allAccessory.push(({id: id, name: name, owned: true}))
    })

    figure.missingaccessory.forEach(({id, name}) => {
        allAccessory.push(({id: id, name: name, owned: false}))
    })


    const [accessory, setAccessory] = useState(allAccessory)
    
    const [formState, setFormState] = useState({
        id: figure.id, 
        externalId: figure.figure.id,  
        condition: figure.condition.id, 
        note: figure.note,
        joints: figure.joints,
        oring: figure.oring,
        paint: figure.paint,
        brokenparts: figure.brokenParts,
        elbowcracks: figure.elbowCracks,
        screws: figure.screw,
        price: figure.price,
        displayImage: figure.images.length > 0 ? figure.images[0].id : null
    })
 
 
    const [doRemoveFigure, { loading: removeFigureLoading }] = useMutation(REMOVE_OWNEDFIGURE, {
        onCompleted() {
            props.history.push(collection.forSale ? "/for-sale" : "/my-collection");
            return
          },
        onError() {
            swal({
                text: "Could not remove figure",
                icon: "error"
            })
        },
        refetchQueries: [
            {
                query: OWNEDFIGURE_QUERY,
                variables: {
                    collectionId: collection.id
                }   
            }
        ],

        awaitRefetchQueries: true
        });

    const [doUpdateFigure, { loading: updateFigureLoading }] = useMutation(UPDATE_OWNEDFIGURE, {
        onCompleted() {
            swal(
                {
                    text: figure.figure.name + " is updated!",
                    icon: "success"
                }
            )
            return
        },
        onError() {
            swal(
                {
                    text: "Something went wrong :(",
                    icon: "error"
                }
            )
        },
        refetchQueries: [
            {
                query: OWNEDFIGURE_QUERY,
                variables: {
                    collectionId: collection.id
                },
            }
        ],

        });

    const [executeAddImageToOwnedFigure] = useMutation(ADD_IMAGE_TO_OWNED_FIGURE, {
        refetchQueries: [
            {
                query: OWNEDFIGURE_QUERY,
                variables: {
                    collectionId: collection.id
                }   
            }
        ],
    })

    const [executeRemoveImage, {loading: removeImageLoading}] = useMutation(REMOVE_IMAGE, {
        refetchQueries: [
            {
                query: OWNEDFIGURE_QUERY,
                variables: {
                    collectionId: collection.id
                }   
            }
        ],
        onCompleted: () => {
            setFormState({...formState, displayImage: null})
        }
    })
    

    if (figure === undefined)
    {
        return (
            <>
                <div>Could not find figure</div>
            </>
        )
    }



    const removeFigure = () => {
        swal({
            title: "Remove from collection?",
            text: "Are you sure you want to remove " + figure.figure.name + " from your collection?",
            buttons: true,
            dangermode: true
        }).then((value)  => {
            if (value === true)
            {
                doRemoveFigure({
                    variables: {
                        id: figure.id
                    }
                });
            }
        })           
    }

    const submit = () => {
        let vars = {
            "ownedFigure": {
                "externalId": formState.externalId, 
                "conditionId": formState.condition, 
                "note": formState.note,
                "collectionId": collection.id,
                "joints": formState.joints,
                "oring": formState.oring,
                "paint": formState.paint,
                "brokenParts": formState.brokenparts,
                "price": parseInt(formState.price),
                "elbowCracks": formState.elbowcracks,
                "screw": formState.screws
            },
            "id": formState.id,
            "accessory": accessory.filter(x => x.owned === true).map(({id}) => {
                return {
                    externalId: id,
                    conditionId: formState.condition,
                    ownedFigureId: formState.id
                }
            })            
        }

        doUpdateFigure({
            variables: vars,
        });
    }

    const close = () => {
        props.history.push(collection.forSale ? "/for-sale" : "/my-collection")
    }

    
    const onStarClick = (nextValue, prevValue, name) => {
        setFormState({...formState, [name]: nextValue})
    }

    const handleToggle = (event) => {
        setFormState({ ...formState, [event.target.name]: event.target.checked })
    }

    const handleFile = ({target}) => {
        let file = target.files[0]
        if (!file) return
        getBase64(file).then(result => {
            setFormState({...formState, image: {file: file, base64: result}})
            let vars = {
                "request": {
                    "ownedFigureId": formState.id, 
                    "base64": result                   
                },
            }
            executeAddImageToOwnedFigure({variables: vars})            
        })

    }

    const removeImage = () => {
        executeRemoveImage({
            variables: {
                imageId: formState.displayImage !== null ? formState.displayImage : figure.images[0].id
            }
        })
    }



   
    const handleChange = (event) => {
        let state = formState
        state[event.target.name] = event.target.value       
        setFormState(state)
    }

    const getBase64 = file => {
        return new Promise(resolve => {
          let baseURL = "";
          let reader = new FileReader();
          reader.readAsDataURL(file);
    
          reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);
          };
        });
      };

    const accessoriesChange = (e) => {
        setAccessory(
            accessory.map((accessory) => 
                accessory.id === e.target.name
                    ? {...accessory, owned: e.target.checked}
                    : {...accessory}
        ))
    }
        
    let img = process.env.REACT_APP_CMS_URL + figure.figure.imageUrlRaw


    if (removeImageLoading) return <SpinnerComponent text="Loading ..." />


    return (
        <>
            {
                figure !== null
                ?
                (
                    <>

                        <div className="container mb-20">
                            <div className="w-full flex justify-center items-center mb-2 sm:mb-6 flex-col">
                                <h1 className="mb-0 text-xl lg:text-4xl">{figure.figure.name} ({figure.figure.type})</h1>
                            </div>

                            <EditFigureMenu figureId={figure.id} />

                            <div className="flex-col w-full flex md:flex-row mt-6">
                                <div className="w-full md:w-4/12 flex flex-col items-start flex-grow mt-2">
                                    <div className="w-full flex justify-center md:justify-start ">
                                    <img 
                                        className="w-full md:w-3/4 lg:w-10/12" 
                                        alt="Bilde av {figure.figure.name}"
                                        src={figure.images.length > 0 
                                            ? formState.displayImage === null 
                                                ? `https://gijoe-io.imgix.net/${figure.images[0]?.location}?w=400` 
                                                : `https://gijoe-io.imgix.net/${figure.images.filter(x => x.id === formState.displayImage)[0]?.location}?w=400` 
                                        : `${img}?width=600` } 
                                    />
                                    
                                    </div>
                                    {figure.images.length > 0 && (<>
                                        <div className="">
                                                <div className="cursor-pointer" onClick={removeImage}>Delete image </div>
                                        </div>
                                    </>
                                    )}

                                    <div className="mb-7">
                                    </div>

                                    <div className="w-full flex">
                                        {figure.images.length > 0 && (<>
                                            {figure.images.map(({location, id}, idx) => (
                                                <>
                                                    <img 
                                                        key={idx}
                                                        className="img-fluid lazyload" 
                                                        alt={`Bilde av ${figure.figure.name}`}
                                                        data-src={`https://gijoe-io.imgix.net/${location}?ar=0.5&h=100&mode=crop`}
                                                        src="data:image/jpeg;base64,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"
                                                        style={{margin:"5px", cursor: 'pointer'}}
                                                        onClick={() => setFormState({...formState, displayImage: id})}
                                                        height={100}
                                                    />
                                                </>
                                            ))}
                                            </>
                                        )}
                                        <FileUploadImage handleFile={handleFile} />

                                    </div>
                                </div>

                                <div className="w-full md:w-8/12">
                                    <div className="w-full mb-2">
                                        <label htmlFor="sitetype">General condition</label>
                                        <select name="condition" onChange={handleChange} defaultValue={figure.condition.id} className="input-base w-full">
                                            <option value="none" disabled>Choose condition</option>
                                            {
                                                props.conditions.conditions.map(({id, name}) => (
                                                <option key={id} value={id}>{name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="w-full mb-2">
                                        <label htmlFor="note">Note</label>
                                        <textarea rows={7} onChange={handleChange} defaultValue={figure.note} name="note" className="input-base w-full" placeholder="Note" />
                                    </div>

                                    <div className="w-full flex mb-2 flex-wrap">
                                        <div className="w-1/2">
                                            <div className="form-group">
                                                Joints<br/> 
                                                <StarRatingComponent 
                                                    name="joints"
                                                    starCount={6}
                                                    value={formState.joints}
                                                    onStarClick={onStarClick}
                                                />
                                            </div>
                                        </div>

                                        <div className="w-1/2">
                                            <div className="form-group">
                                                O-Ring<br/> 
                                                <StarRatingComponent 
                                                    name="oring"
                                                    starCount={6}
                                                    value={formState.oring}
                                                    onStarClick={onStarClick}

                                                />
                                            </div>
                                        </div>


                                        <div className="w-1/2">
                                            <div className="form-group">
                                                Paint<br/> 
                                                <StarRatingComponent 
                                                    name="paint"
                                                    starCount={6}
                                                    value={formState.paint}
                                                    onStarClick={onStarClick}

                                                />
                                            </div>
                                        </div>

                                        <div className="w-1/2">
                                            <div className="form-group">
                                                Screws<br/> 
                                                <StarRatingComponent 
                                                    name="screws"
                                                    starCount={6}
                                                    value={formState.screws}
                                                    onStarClick={onStarClick}

                                                />
                                            </div>
                                        </div>                                        
                                    </div>     

                                    <div className="w-full mb-2">
                                        <div className="">
                                            
                                            <input checked={formState.brokenparts} onChange={handleToggle} type="checkbox" 
                                                id="brokenparts"
                                                name="brokenparts"
                                            /><label htmlFor="brokenparts">&nbsp;Has any broken parts</label>
                                        </div>
                                    </div>
                                    <div className="w-full mb-2">
                                        <div className="">
                                            
                                            <input checked={formState.elbowcracks} onChange={handleToggle} type="checkbox" 
                                                id="elbowcracks"
                                                name="elbowcracks"
                                            /><label htmlFor="elbowcracks">&nbsp;Has any elbow cracks</label>
                                        </div>
                                    </div>

                                    {collection.forSale && (
                                        <div className="row">
                                            <div className="w-full">
                                                <label htmlFor="price">Price</label><br/>
                                                <input className="input-base" defaultValue={formState.price} type="number" name="price" onChange={handleChange} />
                                            </div>
                                        </div>
                                    )}
                                    
                                    {(figure.ownedaccessory.length > 0 || figure.missingaccessory.length > 0) && (
                                        <ManageAccessories onChange={accessoriesChange} accessory={accessory} />
                                    )} 

                                    <div className="w-full">
                                        <button onClick={submit} className="btn-blue w-full mt-5">{updateFigureLoading ? "Processing ..." : "Update figure"}</button>
                                    </div>
                                    <div className="w-full">
                                        <button onClick={close} className="btn-gray w-full mt-5">Close</button>
                                    </div>
                                    <div className="w-full flex items-center flex-col mt-5">
                                        <button onClick={removeFigure} className="">{removeFigureLoading ? "Processing ..." : "Remove from collection"}</button>
                                    </div>

                                    


                                </div>
                            </div>
                        
                    </div>        
                    </>
                )
                :
                (
                    <>
                        <SpinnerComponent />
                    </>
                )
            }
        </>
    )
}

export default withRouter(EditFigure)
